import { useCallback, useState } from "react";
import { TOTAL_SCREENS } from "../data/screenConfig";
export function useJourneyNavigation(initialScreen = 1) {
  const [currentScreen, setCurrentScreen] = useState(initialScreen);

  const goToScreen = useCallback((screenNumber) => {
    const safeScreen = Math.max(
      1,
      Math.min(TOTAL_SCREENS, Number(screenNumber) || 1),
    );
    setCurrentScreen(safeScreen);
  }, []);

  const goBack = useCallback(() => {
    setCurrentScreen((screen) => Math.max(1, screen - 1));
  }, []);

  const goNext = useCallback(() => {
    setCurrentScreen((screen) => Math.min(TOTAL_SCREENS, screen + 1));
  }, []);

  return { currentScreen, goToScreen, goBack, goNext };
}
